import { TransformStream } from "@yume-chan/stream-extra";
import { ScrcpyOptions1_22 } from "./1_22/options.js";
const KEYFRAME_PTS = BigInt(1) << BigInt(62);
export class ScrcpyOptions1_23 extends ScrcpyOptions1_22 {
    constructor(init) {
        super(init);
    }
    getDefaultValue() {
        return {
            ...super.getDefaultValue(),
            cleanup: true,
        };
    }
    createVideoStreamTransformer() {
        const superStream = super.createVideoStreamTransformer();
        return {
            writable: superStream.writable,
            readable: superStream.readable.pipeThrough(new TransformStream({
                transform(packet, controller) {
                    if (packet.type !== "frame") {
                        controller.enqueue(packet);
                        return;
                    }
                    if (packet.pts !== undefined &&
                        packet.pts & KEYFRAME_PTS) {
                        packet.keyframe = true;
                        packet.pts &= ~KEYFRAME_PTS;
                    }
                    controller.enqueue(packet);
                },
            })),
        };
    }
}
//# sourceMappingURL=1_23.js.map